import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useStores } from "../../core/stores";
import BusinessPlanScreen from "./BusinessPlanScreen";
import { BusinessIntro } from "./ui/BusinessIntro";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessIntro"
>;

export const BusinessPlanIntroScreen = observer((props: Props) => {
  const { businessPlansStore } = useStores();

  const businessPlan = businessPlansStore.byId.get(
    props.route.params.businessUid,
  );

  return (
    <BusinessPlanScreen {...props} hideMenu hideIntroTip>
      {businessPlan && <BusinessIntro businessPlan={businessPlan} />}
    </BusinessPlanScreen>
  );
});

export default BusinessPlanIntroScreen;
